<template>
    <Button label="Iniciar Consitência" icon="pi pi-sync" iconPos="left" class="p-button" />
</template>
